import { INIT_REDUCER } from './SharedActions';
import {SharedReducerState} from "./SharedTypes";

/**
 * Společný store pro různá data, např. pro globální čísleníky pro fieldy atp. Převážně využíván např. fieldy z shared (jako StatField atp.).
 */
const initialState = {
  stores: {}, // mapa název reduceru na jeho store
  reducer: shared
};

export default function shared(
  state: SharedReducerState = initialState,
  action: { type?: string; area: string; store?: Object } = { area: '' }
) {
  switch (action.type) {
    case INIT_REDUCER: {
      const area = action.area;
      return {
        ...state,
        stores: {
          ...state.stores,
          [area]: action.store
        }
      };
    }
    default:
      if (action.area) {
        const stores = state.stores as any;
        const store = stores[action.area] as any;
        if (store) {
          const newStore = store.reducer(store, action);
          return {
            ...state,
            stores: {
              ...state.stores,
              [action.area]: newStore
            }
          };
        } else {
          return state;
        }
      } else {
        return state;
      }
  }
}
